<template>
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-3">
      <button @click="$emit('prev')" class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
      </button>
      <h3 class="text-lg font-semibold dark:text-white min-w-[180px] text-center">
        {{ title }}
      </h3>
      <button @click="$emit('next')" class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
      </button>
      <button @click="$emit('today')" class="text-sm text-primary-500 hover:text-primary-600 font-medium ml-2">
        Today
      </button>
    </div>

    <div v-if="campaigns.length > 0" class="flex items-center gap-2">
      <select
        v-model="selectedCampaignId"
        @change="$emit('filter', selectedCampaignId)"
        class="text-sm border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1.5 bg-white dark:bg-gray-800 dark:text-gray-200">
        <option value="">
          All Campaigns
        </option>
        <option v-for="c in campaigns" :key="c.id" :value="c.id">
          {{ c.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { format } from 'date-fns'

const props = defineProps({
  currentMonth: { type: Date, required: true },
  campaigns: { type: Array, default: () => []}
})

defineEmits(['prev', 'next', 'today', 'filter'])

const selectedCampaignId = ref('')
const title = computed(() => format(props.currentMonth, 'MMMM yyyy'))
</script>
